import { render, staticRenderFns } from "./Gallery5.vue?vue&type=template&id=8ff7a90a&scoped=true"
import script from "./Gallery5.vue?vue&type=script&lang=js"
export * from "./Gallery5.vue?vue&type=script&lang=js"
import style0 from "./Gallery5.vue?vue&type=style&index=0&id=8ff7a90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff7a90a",
  null
  
)

export default component.exports